import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { useEffect } from "react";

export const zoneMode = atomWithStorage("zoneMode", false, undefined, {
  getOnInit: true,
});

export function useZoneMode() {
  const [isZoneMode, setZoneMode] = useAtom<boolean>(zoneMode);

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.dataset.zone = isZoneMode ? "true" : "false";
    }
  }, [isZoneMode]);

  return [isZoneMode, setZoneMode] as const;
}
